import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MaskitoDirective } from '@maskito/angular';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { MatCheckbox } from '@angular/material/checkbox';
import { NgForOf } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CondicaoQualidadeStateService, EtapasDeEdicaoService } from '../../services';
import { PQRQuadroFuncionariosRemuneracaoDto } from '../../dtos';
import { MatIconButton } from '@angular/material/button';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { mask_dinheiro } from '../../directives/mascaras';
import { Router, } from '@angular/router';
import { MenuSuspensoComponent } from '../../shared/menu-suspenso/menu-suspenso.component';
import { RodapeFonteNotaComponent } from '../../shared/rodape-fonte-nota/rodape-fonte-nota.component';
import { DialogRestaurarValoresComponent } from '../../shared/dialog-restaurar-valores/dialog-restaurar-valores.component';
import { DialogPadraoQuadroFuncionariosComponent } from '../../shared/dialog-padrao-quadro-funcionarios/dialog-padrao-quadro-funcionarios.component';
import {
  opcoesMenuLateralAtivas,
} from '../../layouts/layout-editor/template/lateral-navegacao-condicao-qualidade';
import { ValidacaoResult, ValidadorTela } from '../../interfaces/validacao.interface';
import { PtBrNumberDirective } from '../../directives/pt-br-number.directive';

export enum EnumFormacao {
  Medio = 'Médio',
  Superior = 'Superior',
  Mestrado = 'Mestrado',
  Doutorado = 'Doutorado',
  Selecione = 'Selecione',
  Especializacao = 'Especialização',
}

@Component({
  selector: 'app-carreira-remuneracao-professores',
  standalone: true,
  imports: [
    NgForOf,
    MatIcon,
    MatTooltip,
    FormsModule,
    MatCheckbox,
    MatIconButton,
    TabelaComponent,
    MaskitoDirective,
    MenuSuspensoComponent,
    PtBrNumberDirective
  ],
  templateUrl: './quadro-funcionarios-remuneracao.component.html',
  styleUrl: './quadro-funcionarios-remuneracao.component.scss',
})
export class QuadroFuncionariosRemuneracaoComponent implements OnInit, ValidadorTela {
  @ViewChild('infoTooltip') infoTooltip!: MatTooltip;
  @ViewChild('menuTooltip') menuTooltip!: MatTooltip;

  mensagensInconsistencia: string[] = [];

  opcoesLateralAtivas = opcoesMenuLateralAtivas;
  menuTooltipVisible = false;

  public mask_dinheiro = mask_dinheiro;
  public pqrQuadroFuncionariosRemuneracaoPadrao: PQRQuadroFuncionariosRemuneracaoDto[] = [];
  public pqrQuadroFuncionariosRemuneracaoValores: PQRQuadroFuncionariosRemuneracaoDto[] = [];

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private dialogRestaurarValores: MatDialog,
    private dialogPqrPadraoQuadroFuncionarios: MatDialog,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
  ) { }

  ngOnInit(): void {
    if (this.condicaoQualidadeStateService.carregando.getValue()) {
      this.condicaoQualidadeStateService.carregando.subscribe(() => {
        this.carregarDados();
        return;
      });
    }

    this.carregarDados();
  }

  carregarDados() {
    this.pqrQuadroFuncionariosRemuneracaoPadrao = this.condicaoQualidadeStateService.getPQRQuadroFuncionariosRemuneracaoPadrao();

    if (
      this.condicaoQualidadeStateService.getPQRQuadroFuncionariosRemuneracaoValores()
        .length === 0
    ) {
      this.pqrQuadroFuncionariosRemuneracaoValores = JSON.parse(
        JSON.stringify(this.pqrQuadroFuncionariosRemuneracaoPadrao),
      );
      return;
    }

    this.pqrQuadroFuncionariosRemuneracaoValores = JSON.parse(
      JSON.stringify(
        this.condicaoQualidadeStateService.getPQRQuadroFuncionariosRemuneracaoValores(),
      ),
    );
  }

  public atualizarValores() {
    this.condicaoQualidadeStateService.setPQRQuadroFuncionariosRemuneracaoValores(this.pqrQuadroFuncionariosRemuneracaoValores);
  }

  public adicionarLinha() {
    const novoValor = JSON.parse(JSON.stringify(this.pqrQuadroFuncionariosRemuneracaoPadrao[0]));
    const ultimoRegistro = this.pqrQuadroFuncionariosRemuneracaoValores[this.pqrQuadroFuncionariosRemuneracaoValores.length - 1];
    novoValor.id = ultimoRegistro ? ultimoRegistro.codPqrQuadroFuncionariosRemuneracao + 1 : 1;
    novoValor.codPqrQuadroFuncionariosRemuneracao = novoValor.id;

    novoValor.codPqrQuadroFuncionariosRemuneracao = novoValor.id;
    novoValor.mesAnoReferencia = ultimoRegistro.mesAnoReferencia;
    novoValor.tipoFuncao = { ... ultimoRegistro.tipoFuncao }
    novoValor.tipoFuncao.codTipoFuncao = ultimoRegistro.tipoFuncao.codTipoFuncao + 1;

    this.pqrQuadroFuncionariosRemuneracaoValores.push(novoValor);
    this.atualizarValores();
  }

  public excluirLinha(dados: PQRQuadroFuncionariosRemuneracaoDto) {
    this.pqrQuadroFuncionariosRemuneracaoValores = this.pqrQuadroFuncionariosRemuneracaoValores.filter((valor) => valor.codPqrQuadroFuncionariosRemuneracao !== dados.codPqrQuadroFuncionariosRemuneracao);
    this.atualizarValores();
  }

  openDialogPqrValoresPadrao() {
    const dialogRef = this.dialogPqrPadraoQuadroFuncionarios.open(
      DialogPadraoQuadroFuncionariosComponent,
      {
        panelClass: 'dialog-pqr-padrao-quadro-funcionarios',
        position: { top: '2%' },
      },
    );

    const dialogInstance = dialogRef.componentInstance as DialogPadraoQuadroFuncionariosComponent;
    dialogInstance.pqrQuadroFuncionariosRemuneracaoPadrao = this.pqrQuadroFuncionariosRemuneracaoPadrao;
  }

  openDialogRestaurarValores() {
    const openedDialog = this.dialogRestaurarValores.open(DialogRestaurarValoresComponent, {
      panelClass: 'dialog-restaurar-valores',
      position: { top: '2%' },
    });

    openedDialog.afterClosed().subscribe((result: any) => {
      if (result) {
        this.configurarValoresPadrao();
        this.toastr.success('Os valores foram restaurados', 'PQR!');
      }
    });
  }

  chamarAcao(acao: string) {
    if (acao === 'pqrDestaFuncionalidade') {
      this.pqrDestaFuncionalidade();
      return;
    }

    if (acao === 'restaurarValoresComBaseNoPqr') {
      this.restaurarValoresComBaseNoPqr();
      return;
    }

    if (acao === 'pqrCompletoEmNovaAba') {
      this.pqrCompletoEmNovaAba();
      return;
    }
  }

  pqrDestaFuncionalidade() {
    this.openDialogPqrValoresPadrao();
  }

  restaurarValoresComBaseNoPqr() {
    this.openDialogRestaurarValores();
  }

  public configurarValoresPadrao() {
    this.pqrQuadroFuncionariosRemuneracaoValores =
      JSON.parse(JSON.stringify(this.pqrQuadroFuncionariosRemuneracaoPadrao));

    this.condicaoQualidadeStateService
      .setPQRQuadroFuncionariosRemuneracaoValores(this.pqrQuadroFuncionariosRemuneracaoValores);
  }

  pqrCompletoEmNovaAba() {
    const baseUrl = window.location.href.replace(this.router.url, '');
    const url = new URL('pqr', baseUrl).href;
    window.open(url, '_blank');
  }

  openTooltips() {
    this.menuTooltipVisible = true;
    setTimeout(() => {
      this.infoTooltip.show();
      this.menuTooltip.show();
    }, 100);
  }

  closeTooltips() {
    this.menuTooltipVisible = false;
    setTimeout(() => {
      this.infoTooltip.hide();
      this.menuTooltip.hide();
    }, 100);
  }

  public mapearFormacoes() {
    return Object.values(EnumFormacao);
  }

  criaMensagemInconsistencia(): string[] {
    const mensagens: string[] = [];

    this.pqrQuadroFuncionariosRemuneracaoValores.forEach((dados) => {


      if(Number(dados.qntMaxEscola)!==1){

        (Number(dados.qntMatriculaProfissional) ?? 0) <= 0 && mensagens.push(
          `Na linha da área de atuação "${dados.tipoFuncao.areaAtuacao}", a `+
          `"Quantidade de Matrícula / Profissional" deve ser maior que zero quando `  +
          `"Máximo/Escola" é diferente de 1 `
        )

      }

      if (!dados.tipoFuncao.areaAtuacao.trim()) {
        mensagens.push(
          `A descrição da função ${dados.codPqrQuadroFuncionariosRemuneracao} deve ser informada.`,
        );
      }

      if (dados.tipoNivelFormacao.descricao === EnumFormacao.Selecione) {
        mensagens.push(
          `O nível de formação da função ${dados.codPqrQuadroFuncionariosRemuneracao} não é válido. Selecione um valor.`,
        );
      }

      if (dados.remuneracaoBrutaMensal === 0 || dados.remuneracaoBrutaMensal === undefined) {
        mensagens.push(
          `A remuneração média mensal da sequência ${dados.codPqrQuadroFuncionariosRemuneracao} deve ser um valor maior que 0.`,
        );
      }

      if (!dados.tipoFuncao.localizacoes || dados.tipoFuncao.localizacoes.length === 0) {
        mensagens.push(
          `A localização não foi informada para a função ${dados.codPqrQuadroFuncionariosRemuneracao}.`
        );
      }
    });

    return mensagens;
  }

  validar(): ValidacaoResult {
    const mensagens = this.criaMensagemInconsistencia();
    return {
      valido: mensagens.length === 0,
      mensagens: mensagens
    };
  }

  restaurarValoresPadrao(): void {
    this.configurarValoresPadrao();
  }

  isLocalizacaoSelecionada(dados: PQRQuadroFuncionariosRemuneracaoDto, codLocalizacao: number): boolean {
    return dados.tipoFuncao.localizacoes.some(loc => loc.codTipoLocalizacao === codLocalizacao);
  }

  toggleLocalizacao(dados: PQRQuadroFuncionariosRemuneracaoDto, codLocalizacao: number, descricao: string): void {
    const index = dados.tipoFuncao.localizacoes.findIndex(loc => loc.codTipoLocalizacao === codLocalizacao);

    if (index >= 0) {
      dados.tipoFuncao.localizacoes.splice(index, 1);
    } else {
      dados.tipoFuncao.localizacoes.push({
        codTipoLocalizacao: codLocalizacao,
        descricao: descricao
      });
    }

    this.atualizarValores();
  }

}

export function canDeactivateQuadroFuncionariosFn(
  component: QuadroFuncionariosRemuneracaoComponent,
): Observable<boolean> | boolean {
  if (component.criaMensagemInconsistencia().length > 0) {
    return false;
  }
  return true;
}
